import { PayloadAction } from "@reduxjs/toolkit";
import { QuoteCreateState } from "../types";
import { initialSectorWorkflow } from "./sectorWorkflowReducers";

export enum QuoteCreateAdvancedStepsEnum {
  Sector = "sector",
  Scheduler = "scheduler",
  Summary = "summary",
}

export const QUOTE_CREATE_ADVANCED_STEPS: QuoteCreateAdvancedStepsEnum[] = [
  QuoteCreateAdvancedStepsEnum.Sector,
  QuoteCreateAdvancedStepsEnum.Summary,
];

export type QuoteCreateStep = QuoteCreateAdvancedStepsEnum;

const navigationReducers = {
  setStep: (
    state: QuoteCreateState,
    action: PayloadAction<QuoteCreateStep>
  ) => {
    state.stepQuote = action.payload;
  },

  nextStep: (state: QuoteCreateState) => {
    const index = QUOTE_CREATE_ADVANCED_STEPS.indexOf(
      state.stepQuote as QuoteCreateStep
    );

    if (index < QUOTE_CREATE_ADVANCED_STEPS.length - 1) {
      state.stepQuote = QUOTE_CREATE_ADVANCED_STEPS[index + 1];
    }
  },

  previousStep: (state: QuoteCreateState) => {
    const index = QUOTE_CREATE_ADVANCED_STEPS.indexOf(
      state.stepQuote as QuoteCreateStep
    );

    if (index > 0) {
      state.stepQuote = QUOTE_CREATE_ADVANCED_STEPS[index - 1];
    }
  },

  resetStep: (state: QuoteCreateState) => {
    state.stepQuote = QuoteCreateAdvancedStepsEnum.Sector;
  },

  loadQuoteForEdit: (state, action) => {
    const payload = action.payload;

    state.stepQuote = QuoteCreateAdvancedStepsEnum.Summary;
    state.sectorWorkflow = {
      ...initialSectorWorkflow,
      ...(payload.sectorWorkflow ?? {}),
    };
    state.eventScheduler = payload.eventScheduler ?? {};
    if (payload.id) state.id = payload.id;
    state.isEditingAdvancedListItem = true;
  },

  /**
   * Use when starting "Add another service" or after finish/close so stale list `id` cannot trigger update instead of add.
   */
  clearAdvancedListEditContext: (state: QuoteCreateState) => {
    state.isEditingAdvancedListItem = false;
    delete state.id;
  },

};

export default navigationReducers;
